import TopBar from '@components/layout/side-nav/bars/top-bar/top-bar';
import { layoutStyles } from '@components/layout/side-nav/layout/layoutStyle';
import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import type { Socket } from 'socket.io-client';

interface LayoutProps {
  children?: ReactNode;
  socket?: Socket;
}

const Layout = ({ children, socket }: LayoutProps): JSX.Element => {
  const storedItemId = new URL(window.location.href).searchParams.get('itemID');

  return (
    <Box sx={layoutStyles.root}>
      <TopBar socket={socket} ebayItem={Boolean(storedItemId)} />
      <Box component="main" sx={layoutStyles.main}>
        <Box
          sx={
            storedItemId
              ? layoutStyles.topBarWidthCompact
              : layoutStyles.topBarWidth
          }
        />
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
